import { render } from "./GimSubBrandAdmin.vue?vue&type=template&id=161bf9ca"
import script from "./GimSubBrandAdmin.vue?vue&type=script&lang=js"
export * from "./GimSubBrandAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__